/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Column, Heading, Row, Spacer } from 'school-space-client/components';

const css = {
    formWrapper: {
        position: 'relative',
        paddingTop: '120%'
    },
    form: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 0
    }
};

const ReserveASpace = () => (
    <main>
        <Row>
            <Column s={[6]} m={[12]} l={[12]}>
                <Heading level="1" size="x-large">
                    Reserve a space
                </Heading>
            </Column>
        </Row>
        <Spacer height={1.5} />
        <Row>
            <Column s={[6]} m={[12]} l={[12]}>
                <div css={css.formWrapper}>
                    <iframe
                        css={css.form}
                        title="Out of hours booking form"
                        src="https://docs.google.com/a/school-space.org/forms/d/e/1FAIpQLSeu1hRQCJxDNWVrJU5Mj9diDw61y3LtOZtXv8xY1J_Aq2t3aw/viewform?embedded=true"
                        frameBorder="0"
                        marginHeight="0"
                        marginWidth="0"
                    >
                        Loading...
                    </iframe>
                </div>
            </Column>
        </Row>
    </main>
);

export default ReserveASpace;
